module.exports = __webpack_public_path__ + "static/media/usd-circle.871e53d3.svg";